export const Types = {
  INITIALIZE: 'uiResults/INITIALIZE',
};

export const Actions = {
  initialize: () => ({
    type: Types.INITIALIZE,
  }),
};



// WEBPACK FOOTER //
// ./src/redux/ui/results/actions.js